import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { FC } from 'react';
import { faStar } from '@fortawesome/pro-solid-svg-icons';
import { faStar as faStarOutline } from '@fortawesome/pro-regular-svg-icons';
import cx from 'classnames';
import { usePhotoStarToggle } from '../hooks/usePhotoStarToggle';
import { showChangesMadeToast, showErrorDialog } from '../helpers';

interface IProps {
    nhID: number;
    assetID: number;
    assetTypeID: number;
    isStarred: boolean;
}

const StarredAssetToggle: FC<IProps> = ({
    nhID,
    assetID,
    assetTypeID,
    isStarred
}) => {
    const { mutate } = usePhotoStarToggle(nhID, assetTypeID);

    return (
        <button
            type='button'
            onClick={() => mutate(assetID, { 
                onError: () => showErrorDialog('There was a problem starring this photo'),
                onSuccess: showChangesMadeToast
            })}
            className="absolute top-3 right-3 flex items-center justify-center bg-white bg-opacity-50 rounded-full h-8 w-8 fa-layers fa-fw select-none [&>svg.svg-inline--fa]:top-[-1px]"
        >
            {!!isStarred && (
                <FontAwesomeIcon
                    icon={faStar}
                    className={cx('text-3xl text-yellow-500')}
                />
            )}
            <FontAwesomeIcon
                icon={faStarOutline}
                className={cx('text-3xl', {
                    'text-black': isStarred,
                    'text-gray-500': !isStarred
                })}
            />
        </button>
    );
};

export { StarredAssetToggle };
